import React, { useEffect } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import styles from './EditAnamnese.module.scss';
import { useConsulta } from '../contexts/ConsultaContext';
import FormLabel from './FormLabel';
import Button from './Button';
import { fetchAuth } from '../utils/fetchAuth';

const EditAnamnese: React.FC = () => {
    const { consulta, setConsulta } = useConsulta();
    const [saving, setSaving] = React.useState(false);

    const modified = (() => {
        const edited = consulta?.anamnese?.last_edited;
        const updated = consulta?.anamnese?.last_updated;

        if (!edited || !updated) return false;

        return new Date(edited) > new Date(updated);
    })();

    return (
        <>
            <Container>
                <h5 className="mb-3">Anamnese</h5>
            </Container>
            <Container>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='historicoClinico'
                            >
                                Histórico Clínico:
                            </FormLabel>
                            <textarea
                                id='historicoClinico'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                defaultValue={consulta?.anamnese?.historico_clinico || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.anamnese)
                                        updatedConsulta.anamnese = {
                                            id: -1,
                                            historico_clinico: '',
                                            habitos_vida: '',
                                            queixas_principais: '',
                                            sono_intestino: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.anamnese.historico_clinico = e.target.value;
                                    updatedConsulta.anamnese.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                rows={3}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='historicoClinico'
                            >
                                Hábitos de Vida:
                            </FormLabel>
                            <textarea
                                id='habitosVida'
                               className={[styles['text-area-control'], 'form-control'].join(' ')}
                                defaultValue={consulta?.anamnese?.habitos_vida || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.anamnese)
                                        updatedConsulta.anamnese = {
                                            id: -1,
                                            historico_clinico: '',
                                            habitos_vida: '',
                                            queixas_principais: '',
                                            sono_intestino: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.anamnese.habitos_vida = e.target.value;
                                    updatedConsulta.anamnese.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                rows={3}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='queixasPrincipais'
                            >
                                Queixas Principais:
                            </FormLabel>
                            <textarea
                                id='queixasPrincipais'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                defaultValue={consulta?.anamnese?.queixas_principais || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.anamnese)
                                        updatedConsulta.anamnese = {
                                            id: -1,
                                            historico_clinico: '',
                                            habitos_vida: '',
                                            queixas_principais: '',
                                            sono_intestino: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.anamnese.queixas_principais = e.target.value;
                                    updatedConsulta.anamnese.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                rows={3}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <FormLabel
                                htmlFor='sonoIntestino'
                            >
                                Sono e Intestino:
                            </FormLabel>
                            <textarea
                                id='sonoIntestino'
                                className={[styles['text-area-control'], 'form-control'].join(' ')}
                                defaultValue={consulta?.anamnese?.sono_intestino || ''}
                                onChange={(e) => {
                                    let updatedConsulta = consulta ? { ...consulta } : null;
                                    if (!updatedConsulta)
                                        updatedConsulta = {
                                            id: -1,
                                            title: '',
                                            last_modified: (new Date()).toISOString(),
                                            last_edited: (new Date()).toISOString(),
                                        };
                                    if (!updatedConsulta.anamnese)
                                        updatedConsulta.anamnese = {
                                            id: -1,
                                            historico_clinico: '',
                                            habitos_vida: '',
                                            queixas_principais: '',
                                            sono_intestino: '',
                                            last_updated: (new Date()).toISOString(),
                                        };
                                    updatedConsulta.anamnese.sono_intestino = e.target.value;
                                    updatedConsulta.anamnese.last_edited = (new Date()).toISOString();
                                    setConsulta(updatedConsulta);
                                }}
                                rows={3}
                            ></textarea>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button
                            disabled={!modified || saving}
                            onClick={() => {
                                if (!consulta) return;
                                setSaving(true);
                                fetchAuth(`${process.env.REACT_APP_API_URL}/consultorio/consultations/${consulta.id}/anamnese`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                    },
                                    body: JSON.stringify({
                                        historico_clinico: consulta?.anamnese?.historico_clinico || '',
                                        habitos_vida: consulta?.anamnese?.habitos_vida || '',
                                        queixas: consulta?.anamnese?.queixas_principais || '',
                                        sono_intestino: consulta?.anamnese?.sono_intestino || '',
                                    }),
                                })
                                    .then(async (response) => {
                                        if (!response.ok) {
                                            const error_json = await response.json();
                                            throw new Error(error_json.message || 'Erro ao salvar anamnese');
                                        }
                                        return response.json();
                                    })
                                    .then(data => {
                                        if (!consulta) return;
                                        setConsulta({
                                            ...consulta,
                                            anamnese: {
                                                id: -1,
                                                historico_clinico: consulta.anamnese?.historico_clinico || '',
                                                habitos_vida: consulta.anamnese?.habitos_vida || '',
                                                queixas_principais: consulta.anamnese?.queixas_principais || '',
                                                sono_intestino: consulta.anamnese?.sono_intestino || '',
                                                last_updated: (new Date()).toISOString(),
                                                last_edited: (new Date()).toISOString(),
                                            },
                                        });

                                    })
                                    .catch(error => {
                                        console.error('Erro ao salvar anamnese:', error);
                                    })
                                    .finally(() => {
                                        setSaving(false);
                                    });
                            
                            }}
                        >
                            {modified ? (saving ? 'Salvando' : 'Salvar') : 'Salvo'}
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default EditAnamnese;
